import React from 'react';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { Routing } from '../../../../util/routes.util';
import Crumb, { CrumbTemplateProps } from '../Crumb';

export default function UserSettingsCrumb({ current }: CrumbTemplateProps) {
  return (
    <Crumb
      path={Routing.settings.users.overview()}
      text={t(TranslationKey.userManagement).singular.upper}
      current={current}
    />
  );
}
